export default __webpack_public_path__ + "static/media/image-graphic-design.48db9c2e.jpg";